import { render } from "./SalesRefundReport.vue?vue&type=template&id=038074b8&ts=true"
import script from "./SalesRefundReport.vue?vue&type=script&lang=ts"
export * from "./SalesRefundReport.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__